// @flow
import * as React from "react";

import Spinner from "views/UI/Spinner";

const DELAY = 300;

type Props = {
  message?: string,
};

function PageLoader({ message }: Props): React.Node {
  const [visible, setVisible] = React.useState<boolean>(false);

  React.useEffect(() => {
    const timeoutId = setTimeout(() => setVisible(true), DELAY);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div className="text-center p-2">
      <Spinner size="large" />
      {message != null && message !== "" ? <div className="mt-2">{message}</div> : null}
    </div>
  );
}

export default PageLoader;
